import api from "./api";

const instituteService = {
  // GET all institutes with search, sort, pagination
  getInstitutes: (params) => api.get("/admin/get-all-institutes", { params }),

  getInstituteById: (id) => api.get("/admin/get-institute-details", { params: { id } }),

  createInstitute: (instituteData) => {
    const formData = new FormData();
    
    Object.keys(instituteData).forEach(key => {
      if (instituteData[key] !== null && instituteData[key] !== undefined && instituteData[key] !== '') {
        formData.append(key, instituteData[key]);
      }
    });
    
    return api.post("/admin/create-institute", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  updateInstitute: (id, instituteData) => {
    const formData = new FormData();
    Object.keys(instituteData).forEach(key => {
      if (instituteData[key] !== null && instituteData[key] !== undefined && instituteData[key] !== '') {
        if (key === 'profileImage' && instituteData[key] instanceof File) {
          formData.append(key, instituteData[key]);
        } else if (key !== 'profileImage') {
          formData.append(key, instituteData[key]);
        }
      }
    });
    return api.put("/admin/update-institute", formData, {
      params: { id },
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // DELETE institute
  deleteInstitute: (id) => api.delete("/admin/delete-institute", { params: { id } }),

  // UPDATE institute status (active/inactive)
  updateInstituteStatus: (id, status) =>
    api.put("/admin/institute-status-update", { status }, { params: { id } }),

  // GET institute departments
  getInstituteDepartments: (instituteId) =>
    api.get("/admin/get-all-institute-departments", { params: { instituteId } }),

  // EXPORT institutes to CSV
  exportInstitutes: (params) =>
    api.post("/admin/export-all-institutes-csv", params),

  // IMPORT institutes from CSV
  importInstitutes: (fileData) =>
    api.post("/admin/import-institute-csv", fileData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  // DOWNLOAD CSV template
  downloadCsvTemplate: () =>
    api.post("/admin/download-institute-format-csv"),

  getAllInstituteStudents: (params) => api.get("/institute/get-all-institutes-students", { params }),

  // SWITCH TO INSTITUTE CONTEXT (for superAdmin)
  switchToInstitute: (instituteId) =>
    api.post(`/super/admin/switch-to-institute/${instituteId}`),

  // SWITCH BACK TO SUPER ADMIN
  switchBackToSuperAdmin: (superAdminId) =>
    api.post("/super/admin/switch-back-to-super-admin", { superAdminId }),
};

export default instituteService;
